import { Box, Stack } from '@mui/material'
import LactationLogo from 'assets/LactationLogo'
import { roundingNumber } from 'components/shared/processes'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { showMilkYieldUi } from 'utils/companyMilkFeatures'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../baseWidget'

export const RejectedMilkYieldWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (
		!permissions?.license_identification ||
		!showMilkYieldUi(userData?.company?.id) ||
		error
	)
		return null

	const rejectedLiters = statistics?.milkings.rejected_milk

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.blueBg,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<LactationLogo color={COLORS.blue} width={16} height={12} />
				</Box>
			}
			path={'/feed/milk-yield'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' gap='4px' alignItems='center'>
					{(rejectedLiters || rejectedLiters === 0) && (
						<TypographyPrimary16Bold
							sx={{ color: rejectedLiters > 0 ? COLORS.error : COLORS.black }}
						>
							{roundingNumber(rejectedLiters, 1).toLocaleString()}
						</TypographyPrimary16Bold>
					)}
					<TypographySecondary
						sx={{ color: rejectedLiters > 0 ? COLORS.error : COLORS.secondary }}
					>
						{rejectedLiters || rejectedLiters === 0 ? 'л' : '-'}
					</TypographySecondary>
				</Stack>
				<TypographyPrimary>Суммарный бракованный надой</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
